import { merge } from 'lodash';
import { restrictionsApplier } from './apply';
import { checkRestrictions } from './checkBillingRestrictions';

// TODO: add memoize
export const restrictCard = function(card, workspace) {
    const newObj = merge({ products: { results: [] } }, card);
    const payload = { workspace, allowPastDue: true };

    restrictionsApplier.applyTo({
        card: newObj,
        billing: workspace.billing,
        projectVersion: workspace.projectVersion,
    });

    checkRestrictions('seo', payload, card, (_, approve) => {
        if (!approve) {
            newObj.seo.title = '';
            newObj.seo.description = '';
        }
    });
    return Object.assign(newObj, {
        messengers: newObj.messengers.filter((m) => m.enabled),
        links: newObj.links.filter((l) => l.enabled),
        products: Object.assign({}, newObj.products, {
            results: newObj.products.results.filter((p) => p.published),
        }),
    });
};
